import { MatLabel } from '@angular/material/form-field';
import {Component, OnInit, Injector, ChangeDetectionStrategy} from "@angular/core";
import {LoginComponent} from "@mango/authentication";
import {MatDialog} from "@angular/material/dialog";
import {ForgotPasswordDialogComponent} from "./forgot-password/forgot-password-dialog.component";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LayoutDirective, LayoutAlignDirective } from "@ngbracket/ngx-layout/flex";
import { MatCard, MatCardTitle, MatCardContent } from "@angular/material/card";
import { MatIcon } from "@angular/material/icon";
import { MatFormField, MatInput } from "@angular/material/input";
import { MgFormControlDirective } from "@mango/core";
import { MatButton } from "@angular/material/button";
import { MatProgressSpinner } from "@angular/material/progress-spinner";

@Component({
    selector: "app-login",
    templateUrl: "./login.component.html",
    styleUrls: ["./login.component.css"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [FormsModule, ReactiveFormsModule, LayoutDirective, LayoutAlignDirective, MatCard, MatCardTitle, MatCardContent, MatIcon, MatFormField, MatLabel, MatInput, MgFormControlDirective, MatButton, MatProgressSpinner]
})
export class AppLoginComponent extends LoginComponent implements OnInit {

  randomNumber: number;
  forgotPasswordEmail: string;

  backgroundPictureCount: number = 8;

  constructor(injector: Injector, public dialog: MatDialog) {
    super();

    this.randomNumber = Math.floor(Math.random() * this.backgroundPictureCount) + 1;
  }

  getRandomBackground(): string {
    return `assets/login-photos/${this.randomNumber}.jpg`;
  }

  openForgotPasswordDialog() {
    this.dialog.open(ForgotPasswordDialogComponent);
  }
}
